import React from "react";
import CustomButton from "./CustomButton";
import { useNavigate } from "react-router-dom";
import { apiHandler } from "../assets/api/index.js";
import { endpoint } from "../assets/api/endpoint";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const LeaveGameModal = ({ onClose ,filteredData}) => {
  const navigate = useNavigate();
  const { gameId } = useParams();
  const gameId1 = filteredData?.additionalData?.gameId
  const { accessToken } = useSelector((state) => state.loginInfo);

  const handleYesClick = async () => {
    try {
      const result = await apiHandler({
        url: `${endpoint.LEAVE_GAME}?gameId=${gameId || gameId1 }`,
        method: "POST",
        authToken: accessToken?.accessToken,
      });
      if(result?.data?.message){
      toast.success(result?.data?.message);
      }else{
        toast.error(result?.data?.error_description);
      }
    } catch (error) {
      toast.error("Something went wrong please try again");
    }
    navigate(-1);
  };

  const handleNoClick = () => {
    navigate(-1)
    onClose();
  };

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        style={{
          width: "400px",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          padding: "20px",
          textAlign: "center",
        }}
      >
        {/* Icon */}
        <div className="text-primary mb-3">
          <div
            className="rounded-circle d-inline-flex justify-content-center align-items-center"
            style={{
              width: "50px",
              height: "50px",
              border: "2px solid #007bff",
              fontSize: "1.5rem",
            }}
          >
            ?
          </div>
        </div>

        {/* Title */}
        <h5 className="fw-bold mb-3">
          Are You Sure You Want to Leave the Game?
        </h5>

        {/* Warning Text */}
        <p className="text-danger small">
          You are leaving  before the game start, your reliability level
          can be affected
        </p>

        {/* Buttons */}
        <div className="d-flex justify-content-center">
          <CustomButton
            buttonText={"Yes"}
            className="border"
            style={{
              width: "70px",
              height: "48px",
              borderRadius: "12px",
              background: "#006FFD",
              color: "#FFFFFF",
              marginRight: "15px",
            }}
            onClick={handleYesClick}
          />
          <CustomButton
            buttonText={"No"}
            className="border"
            style={{
              width: "70px",
              height: "48px",
              borderRadius: "12px",
              background: "#006FFD",
              color: "#FFFFFF",
            }}
            onClick={handleNoClick}
          />
        </div>
      </div>
    </div>
  );
};

export default LeaveGameModal;
